<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35.973"
      height="30.623"
      viewBox="0 0 35.973 30.623"
      class="scaling-svg"
    >
      <g color="#b2b1b7">
        <path
          d="M12.75,25.5A12.75,12.75,0,1,1,25.5,12.75,12.764,12.764,0,0,1,12.75,25.5Zm0-22.667a9.917,9.917,0,1,0,9.917,9.917A9.928,9.928,0,0,0,12.75,2.833Z"
          transform="translate(1.475)"
        />
        <path
          d="M.6.256A1.417,1.417,0,0,1,2.577.6a6.072,6.072,0,0,0,3.5,2.436C7.473,3.33,9.408,3.012,11.7.469a1.417,1.417,0,0,1,2.106,1.9c-2.811,3.124-5.716,3.987-8.3,3.45A8.9,8.9,0,0,1,.256,2.229,1.417,1.417,0,0,1,.6.256Z"
          transform="translate(7.142 11.333)"
        />
        <path
          d="M.326,3.4A5.478,5.478,0,0,1,5.725,0a1.417,1.417,0,0,1,0,2.833,2.669,2.669,0,0,0-2.746,1.56,2.956,2.956,0,0,0,.915,3.1,1.417,1.417,0,1,1-2,2A5.77,5.77,0,0,1,.326,3.4Z"
          transform="translate(0 2.833)"
        />
        <path
          d="M6.816,3.4A5.478,5.478,0,0,0,1.417,0a1.417,1.417,0,0,0,0,2.833,2.669,2.669,0,0,1,2.746,1.56,2.956,2.956,0,0,1-.915,3.1,1.417,1.417,0,1,0,2,2A5.77,5.77,0,0,0,6.816,3.4Z"
          transform="translate(21.309 2.833)"
        />
      </g>
      <g transform="translate(-155.787 -626.323)">
        <g transform="translate(173.887 639.073)">
          <path
            d="M8.936,0a8.936,8.936,0,1,0,8.936,8.936A8.939,8.939,0,0,0,8.936,0Z"
            transform="translate(0 0)"
            fill="#b2b1b7"
          />
        </g>
        <path
          d="M7.447,4.841H4.841V7.447a.745.745,0,0,1-1.489,0V4.841H.745a.745.745,0,1,1,0-1.489H3.351V.745a.745.745,0,0,1,1.489,0V3.351H7.447a.745.745,0,1,1,0,1.489Z"
          transform="translate(178.728 643.913)"
          fill="#fff"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class AddContractorDisabledIcon extends Vue {}
</script>

<style></style>
